import * as React from 'react';

import { DialogFooter } from 'src/components/resourceDialog/DialogFooter';
import { useProjectVirtualGraphPreviewDialog } from 'src/containers/ProjectVirtualGraphPreviewDialog/context/useProjectVirtualGraphPreviewDialog';
import * as copy from 'src/templates/copy';

export const ProjectVirtualGraphPreviewDialogFooter: React.VFC = () => {
  const { footerOptions } = useProjectVirtualGraphPreviewDialog();

  return (
    <DialogFooter
      footerOptions={footerOptions}
      nextButtonLabel={copy.components.virtualGraphPreviewDialog.nextButton}
    />
  );
};
